import { type RootState } from "~/app/store";

export const saActiveTab = (state: RootState) => state.sa.activeTab;
